import React, { useEffect } from 'react'
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css'
import './Night.css'
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { Modal } from 'antd';
import Login from './pages/Login';
import * as faceapi from 'face-api.js';
import Test from './pages/test/Test';
import { useStore } from './store/Store';
import TestLast from './pages/test/TestLast';
import { acknowledgeSessionReplacement, clearAuth } from './host/Config';
export default function App() {
  const setfaceapi=useStore(state=>state.setfaceapi)
  const dark=useStore(state=>state.dark)
const location =useLocation()
  const [sessionReplaced, setSessionReplaced] = React.useState(false);
useEffect(()=>{
 
  Promise.all([
    faceapi.nets.tinyFaceDetector.loadFromUri('/face'),
    faceapi.nets.faceLandmark68Net.loadFromUri('/face'),
    faceapi.nets.faceRecognitionNet.loadFromUri('/face'),
    faceapi.nets.ssdMobilenetv1.loadFromUri('/face'),
  ]).then(() => {
    setfaceapi(faceapi)
   
  }).catch(()=>{
   console.log('error')
  })
},[])

useEffect(() => {
  const onSessionReplaced = () => setSessionReplaced(true);
  window.addEventListener('e-test-session-replaced', onSessionReplaced);

  return () => {
    window.removeEventListener('e-test-session-replaced', onSessionReplaced);
  };
},[])

const closeReplacedSession = () => {
  clearAuth();
  acknowledgeSessionReplacement();
  window.location.replace('/');
};

  return (
    
    <div className={`${dark?"dark":'light'}`}>
    <Modal
      open={sessionReplaced}
      wrapClassName="session-replaced-modal"
      width={520}
      closable={false}
      maskClosable={false}
      keyboard={false}
      title={
        <div className="session-replaced-modal__title">
          <div className="session-replaced-modal__icon" aria-hidden="true">!</div>
          <div>
            <span>XAVFSIZLIK XABARI</span>
            <h2>Hisobingizdan chiqildi</h2>
          </div>
        </div>
      }
      okText="Kirish sahifasiga o‘tish"
      okButtonProps={{ className: 'session-replaced-modal__button' }}
      cancelButtonProps={{ style: { display: 'none' } }}
      onOk={closeReplacedSession}
    >
      <div className="session-replaced-modal__body">
        <p>Hisobingizga boshqa qurilmadan kirildi.</p>
        <p className="session-replaced-modal__note">Xavfsizlik uchun ushbu qurilmadagi test sessiyasi yakunlandi. Davom etish uchun qaytadan kiring.</p>
      </div>
    </Modal>
{location.pathname.includes('manual')?<Navigate to="/"/>:<></>}
    <Routes>
    <Route path="/" element={<Login/>}/>
      <Route path="/:region/:branch" element={<Login/>}/>
      <Route path="/test" element={<Test/>}/>
      <Route path="/test-last/:user_id" element={<TestLast/>}/>
     
    </Routes>
    </div>
  )
}
